import { refineContractRequiredMinimum } from "web_myplann/Portfolio/Forms/ContractShared/contractRequiredMinimum";
import {
	getInvestmentBaseShape,
	refineInvestmentDates,
} from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";
import { getManualValueShape } from "web_myplann/Portfolio/PortfolioShared/getManualValueShape";
import { refineManualValue } from "web_myplann/Portfolio/PortfolioShared/refineManualValue";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

export const getBankProductCreateFormSchema = (t: TranslateFunction) =>
	z
		.object({
			...getInvestmentBaseShape(t),
			...getManualValueShape(t),
		})
		.superRefine(refineManualValue(t))
		.superRefine(refineInvestmentDates(t))
		.superRefine(refineContractRequiredMinimum);

export const getBankProductEditFormSchema = (t: TranslateFunction) =>
	z
		.object(getInvestmentBaseShape(t))
		.superRefine(refineInvestmentDates(t))
		.superRefine(refineContractRequiredMinimum);

export type BankProductCreateFormInput = z.input<
	ReturnType<typeof getBankProductCreateFormSchema>
>;
export type BankProductCreateFormOutput = z.output<
	ReturnType<typeof getBankProductCreateFormSchema>
>;
export type BankProductEditFormInput = z.input<
	ReturnType<typeof getBankProductEditFormSchema>
>;
export type BankProductEditFormOutput = z.output<
	ReturnType<typeof getBankProductEditFormSchema>
>;
